export type CartesianAxisEdge = 'top' | 'right' | 'bottom' | 'left' | 'interior';

export interface CartesianAxisLayout {
  xAxis: {
    value: number;
    edge: Extract<CartesianAxisEdge, 'top' | 'bottom' | 'interior'>;
    tickOffsets: readonly [number, number];
    labelDirection: -1 | 1;
  };
  yAxis: {
    value: number;
    edge: Extract<CartesianAxisEdge, 'left' | 'right' | 'interior'>;
    tickOffsets: readonly [number, number];
    labelDirection: -1 | 1;
    labelAnchor: 'start' | 'end';
  };
}

export function getCartesianAxisLayout(
  xDomain: [number, number],
  yDomain: [number, number],
): CartesianAxisLayout {
  const xAxis =
    yDomain[0] >= 0
      ? ({
          value: yDomain[0],
          edge: 'bottom',
          tickOffsets: [-1, 0],
          labelDirection: -1,
        } as const)
      : yDomain[1] <= 0
        ? ({
            value: yDomain[1],
            edge: 'top',
            tickOffsets: [0, 1],
            labelDirection: 1,
          } as const)
        : ({
            value: 0,
            edge: 'interior',
            tickOffsets: [-1, 1],
            labelDirection: 1,
          } as const);
  const yAxis =
    xDomain[0] >= 0
      ? ({
          value: xDomain[0],
          edge: 'left',
          tickOffsets: [0, 1],
          labelDirection: 1,
          labelAnchor: 'start',
        } as const)
      : xDomain[1] <= 0
        ? ({
            value: xDomain[1],
            edge: 'right',
            tickOffsets: [-1, 0],
            labelDirection: -1,
            labelAnchor: 'end',
          } as const)
        : ({
            value: 0,
            edge: 'interior',
            tickOffsets: [-1, 1],
            labelDirection: -1,
            labelAnchor: 'end',
          } as const);
  return { xAxis, yAxis };
}

export function boundaryTextAnchor(
  position: number,
  start: number,
  end: number,
): 'start' | 'middle' | 'end' {
  const tolerance = Math.max(1, Math.abs(end - start)) * 1e-9;
  if (Math.abs(position - start) <= tolerance) return 'start';
  if (Math.abs(position - end) <= tolerance) return 'end';
  return 'middle';
}
